//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"DomainRelevancyOption",1,0],[0,"ExternalObjectsSource",1,"TaggedObject",0],[0,"PropertyForMapping",1,0],[0,"TypeMappingMode",1,0]],[[["components","domainRelevancy"],"UpdateDomainRelevancy",{},2,0],[["components"],"DeleteTypeMapping",{},1,0],[["numExternalObjects"],"GetExternalObjects",{R_:{externalObjects:"NXObject[]"}},0,0]],[]];
SPLM.AME.ManageTypeMappingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ManageTypeMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ManageTypeMappingBuilder.DomainRelevancy = Object.freeze({
    "Relevant" : "Relevant", "Undefined" : "Undefined", "Irrelevant" : "Irrelevant"});

export default SPLM;